import { Button } from '@progress/kendo-react-buttons';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { Checkbox, Input } from '@progress/kendo-react-inputs';
import { useEffect, useState } from 'react';
import { BiComment } from 'react-icons/bi';
import { FaEye, FaEyeSlash, FaFileExcel, FaUserCircle } from 'react-icons/fa';
import { MdOutlineAlternateEmail } from "react-icons/md";
import { PiBuildingApartmentFill } from "react-icons/pi";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Images from '../../custom/flagExport';
import { validateUserData } from '../../custom/UserExport';
import { registerUser } from '../../services/dashboard-service/userService';


let passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*\-/]).{6,}$/

const intialState =
{
    FirstName: "",
    LastName: "",
    Email: "",
    Password: "",
    Company: "",
    Comment: "",
    ExcelCount: 1000,
    startDate: new Date(),
    endDate: null,
    allowedServiceOpt: [],
    allowedFeatures: [],
    allowedFieldOpt: ['vehicleid', 'vehiclecount', 'manufacturerid', 'manufacturer', 'modelid', 'model', 'variant', 'enginecode', 'fueltype', 'wvtanr', 'power_kw', 'power_ps', 'capacity_ccm', 'noofcyl', 'noofvalves', 'bodytype', 'drivetype', 'fromdate', 'todate'],
    allowedChildren: false,
    vio_StartDate: null,
    vio_EndDate: null,
}


const intialFieldsData = [
    { id: 1, name: "vehicleid", title: "Vehicle ID", checked: true },
    { id: 2, name: "vehiclecount", title: "Vehicle Count", checked: true },
    { id: 3, name: "manufacturerid", title: "Manufacturer ID", checked: true },
    { id: 4, name: "manufacturer", title: "Manufacturer", checked: true },
    { id: 5, name: "modelid", title: "Model ID", checked: true },
    { id: 6, name: "model", title: "Model", checked: true },
    { id: 7, name: "variant", title: "Variant", checked: true },
    { id: 8, name: "enginecode", title: "Engine Code", checked: true },
    { id: 9, name: "fueltype", title: "Fuel Type", checked: true },
    { id: 10, name: "wvtanr", title: "WVTA Number", checked: true },
    { id: 11, name: "power_kw", title: "Power (kW)", checked: true },
    { id: 12, name: "power_ps", title: "Power (PS)", checked: true },
    { id: 13, name: "capacity_ccm", title: "Capacity (CCM)", checked: true },
    { id: 14, name: "noofcyl", title: "No. of Cylinders", checked: true },
    { id: 15, name: "noofvalves", title: "No. of Valves", checked: true },
    { id: 16, name: "bodytype", title: "Body Type", checked: true },
    { id: 17, name: "drivetype", title: "Drive Type", checked: true },
    { id: 18, name: "fromdate", title: "From Date", checked: true },
    { id: 19, name: "todate", title: "To Date", checked: true },
    { id: 20, name: "KBANumber", title: "KBA Number", checked: true },
    { id: 21, name: "Capacity", title: "Capacity", checked: true },
    { id: 22, name: "FuelMixture", title: "Fuel Mixture", checked: true },
    { id: 23, name: "regplate", title: "Regplate", checked: true },
];

const initlaRouteAccess = [
    { id: 1, name: "VehicleVIOReport", title: "Vehicle VIO", checked: true },
    { id: 2, name: "ArticleVIOReport", title: "Article VIO", checked: true },
]


function UserRegisteration() {
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const [formErrors, setFormErrors] = useState({})
    const [selectedFields, setSelectedFields] = useState([
    ])
    const [routeFields, setRouteFields] = useState(initlaRouteAccess)
    const [userDataList, setUserDataList] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null)
    const [repeatPassword, setRepeatPassword] = useState('')
    const [apiCheckboxList, setApiCheckboxList] = useState([
        { id: 8, name: "Sweden", value: "Sweden", flag: Images["se"], checked: false },
        { id: 3, name: "Finland", value: "Finland", flag: Images["fi"], checked: false },
        { id: 6, name: "Norway", value: "Norway", flag: Images["no"], checked: false },
        { id: 1, name: "Denmark", value: "Denmark", flag: Images["dk"], checked: false },
        { id: 2, name: "Estonia", value: "Estonia", flag: Images["et"], checked: false },
        { id: 9, name: "UK", value: "UK", flag: Images["uk"], checked: false },
        { id: 4, name: "France", value: "France", flag: Images["fr"], checked: false },
        { id: 5, name: "Italy", value: "Italy", flag: Images["it"], checked: false },
        { id: 7, name: "Spain", value: "Spain", flag: Images["sp"], checked: false },
    ]);
    const [selectedApis, setSelectedApis] = useState([]);
    const [formValues, setFormValues] = useState(intialState);
    const [fieldsData, setFieldsData] = useState(intialFieldsData);
    const [selectedRoute, setSelectedRoute] = useState([])
    const [selectAll, setSelectAll] = useState(true)


    const selectAllForColumns = () => {
        setSelectAll((prev) => !prev)
        const newFieldsData = fieldsData.map((item) => ({
            ...item,
            checked: !selectAll
        }))
        setFieldsData(newFieldsData)
        const newItem = newFieldsData.filter((item) => item.checked)
        setSelectedFields(newItem)
        const newItemNames = newItem.map((obj) => obj.name)
        setFormValues((prevValues) => ({
            ...prevValues,
            allowedFieldOpt:newItemNames
        }))
    }
    
    const validateField = (name, value) => {
        const errors = { ...formErrors };
        switch (name) {
            case "FirstName":
                if (!value) {
                    errors.FirstName = "First Name is required";
                } else {
                    delete errors.FirstName;
                }
                break;
            case "LastName":
                if (!value) {
                    errors.LastName = "Last Name is required";
                } else {
                    delete errors.LastName;
                }
                break;
            case "Email":
                if (!value) {
                    errors.Email = "Email Address is required";
                } else if (!/^(?!.*\.{2})(?!^\.)[a-zA-Z0-9._%+-]+(?<!\.)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                    errors.Email = "Invalid Email Address";
                } else {
                    delete errors.Email;
                }
                break;
            case "Password":
                if (!value) {
                    errors.Password = "Password is required";
                } else if (!passwordRegex.test(value)) {
                    errors.Password = "Password must be at least 6 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.";
                } else {
                    delete errors.Password;
                }
                break;
            case "repeatPassword":
                if (!value) {
                    errors.repeatPassword = "Please confirm your password";
                } else if (formValues.Password !== value) {
                    errors.repeatPassword = "Passwords do not match";
                } else {
                    delete errors.repeatPassword;
                }
                break;
            case "startDate":
                if (!formValues.startDate) {
                    errors.startDate = "Start Date is required";
                } else {
                    delete errors.startDate;
                }
                break;

            case "endDate":
                if (!formValues.endDate) {
                    errors.endDate = "End Date is required";
                } else if (formValues.endDate < formValues.startDate) {
                    errors.endDate = "End Date must be greater than or equal to Start Date";
                } else {
                    delete errors.endDate;
                }
                break;
            case "vio_StartDate":
                if (!formValues.vio_StartDate) {
                    errors.vio_StartDate = "VIO Start Date is required";
                } else {
                    delete errors.vio_StartDate;
                }
                break;
            case "vio_EndDate":
                if (!formValues.vio_EndDate) {
                    errors.vio_EndDate = "VIO End Date is required";
                } else if (formValues.vio_EndDate < formValues.vio_StartDate) {
                    errors.vio_EndDate = "VIO End Date must be greater than or equal to VIO Start Date";
                } else {
                    delete errors.vio_EndDate;
                }
                break;
            default:
                break;
        }

        setFormErrors(errors);
    };






    useEffect(() => {
        // Set all fields as selected on initial render
        const initialSelectedFields = fieldsData.filter(field => field.checked);
        setSelectedFields(initialSelectedFields);

        // Store the names of the checked fields in allowedFieldOpt
        const allowedFieldOpt = initialSelectedFields.map(field => field.name);
        setFormValues(prevValues => ({
            ...prevValues,
            allowedFieldOpt: allowedFieldOpt,
        }));
    }, []);

    let userData = validateUserData()
    const togglePasswordVisibility = () => {
        setShowPassword((prevVisibility) => !prevVisibility);
    }

    const toggleRepeatPasswordVisibility = () => {
        setShowRepeatPassword((prevVisibility) => !prevVisibility);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (e.target.name === "Email") {
            validateField("Email", value)
        }
        setFormValues({ ...formValues, [name]: value })
    }

    const handleDateChange = (name, value) => {
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const handleCheckBox = () => {
        setFormValues((prevValues) => ({
            ...prevValues,
            allowedChildren: !prevValues.allowedChildren
        }))
    }


    const validateForm = () => {
        const errors = {};

        // Basic text field validations
        if (!formValues.FirstName) {
            errors.FirstName = "First Name is required";
        }
        if (!formValues.LastName) {
            errors.LastName = "Last Name is required";
        }
        if (!formValues.Email) {
            errors.Email = "Email Address is required";
        } else if (!/\S+@\S+\.\S+/.test(formValues.Email)) {
            errors.Email = "Invalid Email Address ";
        }
        if (!repeatPassword) {
            errors.repeatPassword = "Please confirm your password";
        } else if (formValues.Password !== repeatPassword) {
            errors.repeatPassword = "Passwords do not match";
        }
        if (!formValues.Password) {
            errors.Password = "Password is required";
        } else if (!passwordRegex.test(formValues.Password)) {
            errors.Password = "Password must be at least 6 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.";
        }

        if (!formValues.vio_StartDate) {
            errors.vio_StartDate = "VIO Start Date is required";
        }
        if (!formValues.vio_EndDate) {
            errors.vio_EndDate = "VIO End Date is required";
        } else if (formValues.vio_EndDate < formValues.vio_StartDate) {
            errors.vio_EndDate = "VIO End Date must be greater than or equal to VIO Start Date";
        }

        if (!formValues.startDate) {
            errors.startDate = "Start Date is required";
        }

        // End Date validation
        if (!formValues.endDate) {
            errors.endDate = "End Date is required";
        } else if (formValues.endDate < formValues.startDate) {
            errors.endDate = "End Date must be greater than or equal to Start Date";
        }
        // Excel Count validation
        if (formValues.ExcelCount === undefined && formValues.ExcelCount === null) {
            errors.ExcelCount = "Excel Count is required";
        } else if (formValues.ExcelCount < 0) {
            errors.ExcelCount = "Excel Count must be a valid positive integer";
        }
        const anyFieldSelected = fieldsData.some(field => field.checked);
        if (!anyFieldSelected) {
            errors.selectedFields = "Please select at least one field.";
        }
        // Validation for MultiSelect fields - ensure at least one selection
        if (selectedApis.length === 0) {
            errors.selectedApis = "Please select at least one region access.";
        }
        if (selectedRoute.length === 0) {
            errors.selectedRoutes = "Please select at least one Feature.";
        }
        // Validation for MultiSelect fields - ensure at least one selection
        // if (selectedApis.length === 0) {
        //     errors.selectedApis = "Please select at least one region access.";
        // }
        // if (selectedFields.length === 0) {
        //     errors.selectedFields = "Please select at least one field.";
        // }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const customItemRender = (li, itemProps) => {
        const isChecked = selectedApis.some(api => api.id === itemProps.dataItem.id);
        return (
            <li className="k-item-options">
                <input
                    type="checkbox"
                    style={{ cursor: "pointer", height: "16px", width: "16px", marginRight: "8px" }}
                    checked={isChecked}
                    onChange={(event) => handleCheckboxChangeForRegion(event, itemProps.dataItem)}
                />
                <img
                    src={itemProps.dataItem.flag}
                    alt={itemProps.dataItem.name}
                    style={{ width: "20px", height: "15px", marginRight: "2px", marginLeft: '5px' }}
                />
                <span className="k-checkbox-label">{itemProps.dataItem.name}</span>
            </li>
        );
    };


    const customItemRenderForRoute = (li, itemProps) => {
        const isChecked = selectedRoute.some(api => api.id === itemProps.dataItem.id);
        return (
            <li className="k-item-options">
                <input
                    type="checkbox"
                    style={{ cursor: "pointer", height: "16px", width: "16px", marginRight: "8px" }}
                    checked={isChecked}
                    onChange={(event) => handleCheckboxChangeForRouteFields(event, itemProps.dataItem)}
                />
                <span className="k-checkbox-label">{itemProps.dataItem.title}</span>
            </li>
        );
    };



    const handleCheckboxChangeForRouteFields = (event, dataItem) => {

        const { checked } = event.target;

        setSelectedRoute((prevData) => {
            return prevData.map(item =>
                item.id === dataItem.id ? { ...item, checked } : item
            );
        });

        const updatedSelectedFields = checked
            ? [...selectedRoute, dataItem]
            : selectedRoute.filter(field => field.id !== dataItem.id);
        setSelectedRoute(updatedSelectedFields);

        // Update formValues with the new allowedFieldOpt
        if (checked) {
            setFormValues((prevValues) => ({
                ...prevValues,
                allowedFeatures: [...prevValues.allowedFeatures, dataItem.name],
            }));
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                allowedFeatures: prevValues.allowedFeatures.filter(
                    (field) => field !== dataItem.name
                ),
            }));
        }
    };



    const handleCheckboxChangeForRegionFields = (event, dataItem) => {


        const { checked } = event.target?.element;

        // if (selectedFields.length === 0) {
        //     setFormErrors((prevErrors) => ({
        //         ...prevErrors,
        //         selectedFields: "Please select at least one field."
        //     }));
        // } else {
        //     // Clear error when there's at least one selection
        //     setFormErrors((prevErrors) => ({
        //         ...prevErrors,
        //         selectedFields: null
        //     }));
        // }

        setFieldsData((prevData) => {
            const updatedData = prevData.map(item =>
                item.id === dataItem.id ? { ...item, checked } : item
            );
            const allChecked = updatedData.every((item) => item.checked);
            setSelectAll(allChecked); // Update "Select All" immediately
            return updatedData
        });
        const updatedSelectedFields = checked
            ? [...selectedFields, dataItem]
            : selectedFields.filter(field => field.id !== dataItem.id);
        setSelectedFields(updatedSelectedFields);
        // Update formValues with the new allowedFieldOpt
        if (checked) {
            setFormValues((prevValues) => ({
                ...prevValues,
                allowedFieldOpt: [...prevValues.allowedFieldOpt, dataItem.name],
            }));
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                allowedFieldOpt: prevValues.allowedFieldOpt.filter(
                    (field) => field !== dataItem.name
                ),
            }));
        }
    };

    const handleCheckboxChangeForRegion = (event, dataItem) => {
        const { checked } = event.target;
        let updatedAllowedServiceOpt = [...formValues.allowedServiceOpt];
        if (updatedAllowedServiceOpt.length === 0) {
            updatedAllowedServiceOpt.push({ features: [] })
        }

        let features = [...updatedAllowedServiceOpt[0].features];
        if (checked) {
            if (!features.includes(dataItem.name)) {
                features.push(dataItem.name)
            }
        }
        else {
            features = features.filter((feature) => feature !== dataItem.name)
        }
        updatedAllowedServiceOpt[0].features = features
        // Log the final structure for debugging

        setFormValues((prevValues) => ({
            ...prevValues,
            allowedServiceOpt: updatedAllowedServiceOpt
        }));

        // Sync the selected APIs state for display (this part is unchanged)
        const updatedSelectedApis = [...selectedApis];

        const selectedApiIndex = updatedSelectedApis.findIndex(api => api.id === dataItem.id);

        if (checked && selectedApiIndex === -1) {
            updatedSelectedApis.push(dataItem);
        } else if (!checked && selectedApiIndex > -1) {
            updatedSelectedApis.splice(selectedApiIndex, 1);
        }

        setSelectedApis(updatedSelectedApis);

        const updatedApiCheckboxList = apiCheckboxList.map(api => {
            if (api.id === dataItem.id) {
                return { ...api, checked: checked };
            }
            return api;
        });

        setApiCheckboxList(updatedApiCheckboxList);
    };


    const handleMultiSelectChange = (event) => {
        const newSelectedApi = event.target.value;

        // Handle error message if no region is selected


        if (newSelectedApi.length === 0) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                selectedApis: "Please select at least one region access."
            }));
        }
        else {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                selectedApis: null,
            }));
        }
        // Update the selected APIs
        setSelectedApis(newSelectedApi);

        // Update allowedServiceOpt based on selected APIs
        const detectedRegions = selectedApis.filter(api =>
            !newSelectedApi.some(newApi => newApi.id === api.id)
        );

        if (detectedRegions.length > 0) {
            let updatedAllowedServiceOpt = [...formValues.allowedServiceOpt];
            if (updatedAllowedServiceOpt.length > 0) {
                detectedRegions.forEach(api => {
                    updatedAllowedServiceOpt[0].features = updatedAllowedServiceOpt[0].features.filter(feature => feature !== api.name);
                });
            }
            setFormValues((prevValues) => ({
                ...prevValues,
                allowedServiceOpt: updatedAllowedServiceOpt
            }));
        }
    };



    const handleMultiSelectChangeRoute = (event) => {
        const newSelectedApi = event.target.value;
        // Handle error message if no route access is selected


        if (newSelectedApi.length === 0) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                selectedRoutes: "Please select at least one Feature."
            }));
        }
        else {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                selectedRoutes: null,
            }));
        }
        // Update the selected APIs
        setSelectedRoute(newSelectedApi);

        // Update allowedServiceOpt based on selected APIs
        const detectedRegions = selectedRoute.filter(api =>
            !newSelectedApi.some(newApi => newApi.id === api.id)
        );
        if (detectedRegions.length > 0) {
            let updatedAllowedServiceOpt = [...formValues.allowedFeatures];
            if (updatedAllowedServiceOpt.length > 0) {
                detectedRegions.forEach(api => {
                    updatedAllowedServiceOpt = updatedAllowedServiceOpt.filter(feature => feature !== api.name);
                });
            }
            setFormValues((prevValues) => ({
                ...prevValues,
                allowedFeatures: updatedAllowedServiceOpt
            }));
        }
    };

    const handleRegister = async (e) => {
        // Handle form submission
        e.preventDefault()
        if (!validateForm()) {
            if (formErrors.Password) {
                toast("Password must be at least 6 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.", {
                    type: "error",
                    autoClose: true
                })
                return;
            }
            else if (formValues.Password !== repeatPassword) {
                toast("Password and Repeat-Password does not match", {
                    type: "error",
                    autoClose: true // Set to false to allow users to read all errors
                });
                return;
            }
            else {
                // Show all form validation errors in a single toast
                toast("Please fill out all required fields", {
                    type: "error",
                    autoClose: true // Set to false to allow users to read all errors
                });
            }
            return;
        }

        if (userData && validateForm()) {
            const response = await registerUser(formValues,
                userData.SecretKey,
                formValues.allowedServiceOpt,
                userData?.token)
            if (response?.status === 200) {
                handleCancel();
                toast("User registered successfully!", {
                    type: 'success',
                    autoClose: true
                });
            }
            else if (response?.status === 401 || response?.error?.statusCode === 401) {
                localStorage.removeItem("userData")
                navigate('/login')
                toast.error('Session Expired.')
            }
            else if (response?.status === 409) {
                toast(response?.data, {
                    type: "warning",
                    autoClose: true
                });
            }
            else if (response?.error) {
                toast("Try again later.", {
                    type: "error",
                    autoClose: true
                });
            }
            else {
                toast(response?.message, {
                    type: "error",
                    autoClose: true
                })
            }
        }
        handleCancel()
    };

    const handleCancel = () => {
        // Clear the form or handle cancel logic
        setFormValues(intialState);
        setRepeatPassword('')
        setSelectedApis([])
        setFormErrors({})
        setSelectAll(true)
        setSelectedFields([])
        setFieldsData(intialFieldsData)
        setSelectedUser(null)
        setSelectedRoute([])
    };
    return (

        <div className="create-user-main-container">
            <div className="create-user-form-container">
                <div className="create-user-card">
                    <h1 className='register-h1'>Register</h1>
                    <form>

                        <div className="form-row icon-input" style={{ marginBottom: formErrors?.FirstName ? "0rem" : "0.7rem" }}>
                            <FaUserCircle className="input-icon" />
                            <Input
                                name="FirstName"
                                required
                                type='text'
                                value={formValues.FirstName}
                                onBlur={(e) => validateField(e.target.name, e.target.value)}
                                onChange={handleInputChange}
                                placeholder="First Name*"
                            />
                        </div>
                        {formErrors.FirstName && <div className="error-text">{formErrors.FirstName}</div>}

                        {/* Last Name */}
                        <div className="form-row icon-input" style={{ marginBottom: formErrors?.LastName ? "0rem" : "0.7rem" }}>
                            <FaUserCircle className="input-icon" />
                            <Input
                                name="LastName"
                                required
                                value={formValues.LastName}
                                type='text'
                                onBlur={(e) => validateField(e.target.name, e.target.value)}
                                onChange={handleInputChange}
                                placeholder="Last Name*"
                            />
                        </div>
                        {formErrors.LastName && <div className="error-text">{formErrors.LastName}</div>}

                        {/* Email */}
                        <div className="form-row icon-input" style={{ marginBottom: formErrors?.Email ? "0rem" : "0.7rem" }}>
                            <MdOutlineAlternateEmail className="input-icon" />
                            <Input
                                name="Email"
                                type='email'
                                required
                                onBlur={(e) => validateField(e.target.name, e.target.value)}
                                value={formValues.Email}
                                onChange={handleInputChange}
                                placeholder="Email Address*"
                                style={{
                                    boxShadow: formErrors.Email
                                        ? "0 0 0 3px rgba(255, 0, 0, 0.25)" // Error box shadow
                                        : "" // Default box shadow
                                }}
                            />
                        </div>
                        {formErrors.Email && <div className="error-text">{formErrors.Email}</div>}

                        {/* Company */}
                        <div className="form-row icon-input">
                            <PiBuildingApartmentFill className="input-icon" />
                            <Input
                                name="Company"
                                autoComplete='Company'
                                type='text'
                                value={formValues.Company}
                                onChange={handleInputChange}
                                placeholder="Company"
                            />
                        </div>

                        {/* Password */}
                        <div className="form-row icon-input" style={{ marginBottom: formErrors?.Password ? "0rem" : "0.7rem" }}>
                            <Input
                                name="Password"
                                required
                                autoComplete="new-password"
                                type={showPassword ? "text" : "password"}
                                value={formValues.Password}
                                onBlur={(e) => validateField(e.target.name, e.target.value)}
                                onChange={handleInputChange}
                                placeholder="Password*"

                            />
                            <button
                                type="button"
                                className="input-icon-password"
                                onClick={togglePasswordVisibility}

                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {formErrors.Password && <div className="error-text">{formErrors.Password}</div>}

                        {/* Repeat Password */}
                        <div className="form-row icon-input" style={{ marginBottom: formErrors?.repeatPassword ? "0rem" : "0.7rem" }}>
                            <Input
                                name="repeatPassword"
                                type={showRepeatPassword ? "text" : "password"}
                                autoComplete="new-password"
                                value={repeatPassword}
                                required
                                onBlur={(e) => validateField(e.target.name, e.target.value)}
                                onChange={(e) => setRepeatPassword(e.target.value)}
                                placeholder="Repeat Password*"
                            />
                            <button
                                type="button"
                                className="input-icon-password"
                                onClick={toggleRepeatPasswordVisibility}
                            >
                                {showRepeatPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {formErrors.repeatPassword && <div className="error-text">{formErrors.repeatPassword}</div>}

                        {/* Comment */}
                        <div className="form-row icon-input" style={{ marginBottom: "0.7rem" }}>
                            <BiComment className="input-icon" />
                            <Input
                                type='text'
                                name="Comment"
                                value={formValues.Comment}
                                onChange={handleInputChange}
                                placeholder="Comment"
                            />
                        </div>

                        {/*Excel Download count*/}
                        <div className="form-row icon-input" style={{ marginBottom: "0.7rem" }}>
                            <FaFileExcel className="input-icon" style={{ height: "20px", width: "20px", right: "12px" }} />
                            <Input
                                type='number'
                                name="ExcelCount"
                                value={formValues.ExcelCount}
                                onChange={handleInputChange}
                                placeholder="Excel Count"
                            />
                        </div>
                        {formErrors.ExcelCount && <div className="error-text">{formErrors.ExcelCount}</div>}

                        {/* Region Access */}
                        <div className="form-row-multiselect">
                            <MultiSelect
                                autoClose={false}
                                data={apiCheckboxList}
                                value={selectedApis}
                                onChange={handleMultiSelectChange}
                                textField="name"
                                dataItemKey="id"
                                onBlur={(e) => validateField(e.target.name, e.target.value)}
                                placeholder="Region Access*"
                                itemRender={customItemRender}
                            />
                            {formErrors.selectedApis && !selectedApis?.length > 0 && (
                                <div className="error-text">{formErrors.selectedApis}</div>
                            )}
                        </div>

                        {/* Route Access  / */}
                        <div className="form-row-multiselect">
                            <MultiSelect
                                autoClose={false}
                                data={routeFields}
                                value={selectedRoute}
                                onChange={handleMultiSelectChangeRoute}
                                textField="title"
                                dataItemKey="id"
                                onBlur={(e) => validateField(e.target.name, e.target.value)}
                                placeholder="Feature Access*"
                                itemRender={customItemRenderForRoute}
                            />
                            {formErrors.selectedRoutes && !selectedRoute?.length > 0 && (
                                <div className="error-text">{formErrors.selectedRoutes}</div>
                            )}
                        </div>


                        <div className="multi-select-main-form form-row-multiselect">
                            <div className='checkbox-list' style={{ marginBottom: "1rem" }}>
                                <div className="checkbox-item">
                                    <Checkbox
                                        name="selectall"
                                        label={selectAll ? "Deselect All" : "Select All"}
                                        title="Select All"
                                        checked={selectAll}
                                        onChange={selectAllForColumns} />
                                </div>
                            </div>
                            <div className="checkbox-list">
                                {fieldsData.map((field) => (
                                    <div key={field.id} className="checkbox-item">
                                        <Checkbox
                                            name={String(field.id)}
                                            label={field.title}
                                            title={field.title}
                                            checked={field.checked}
                                            onChange={(e) => handleCheckboxChangeForRegionFields(e, field)}
                                        />
                                    </div>
                                ))}
                            </div>
                            </div>
                            {formErrors.selectedFields && !selectedFields?.length > 0 && (
                                <div className="error-text">{formErrors.selectedFields}</div>
                            )}


                        <div className="form-row-date" style={{ marginBottom: formErrors.startDate ? "0.5rem" : "0.7rem" }}>
                            <DatePicker
                                name="startDate"

                                value={formValues.startDate}
                                onChange={(e) => handleDateChange("startDate", e.value)}
                                onBlur={(e) => validateField(e.target.name, e.target.value)}
                                placeholder="Start Date"
                            />
                        </div>
                        {formErrors.startDate && <div className="error-text">{formErrors.startDate}</div>}


                        <div className="form-row-date" style={{ marginBottom: formErrors.endDate ? "0.5rem" : "0.7rem" }}>
                            <DatePicker
                                name="endDate"
                                value={formValues.endDate}
                                onChange={(e) => handleDateChange("endDate", e.value)}
                                onBlur={(e) => validateField(e.target.name, e.target.value)}
                                placeholder="End Date"
                            />
                        </div>
                        {formErrors.endDate && <div className="error-text">{formErrors.endDate}</div>}

                        <div className="form-row-date" style={{ marginBottom: formErrors.vio_StartDate ? "0rem" : "0.7rem" }}>
                            <DatePicker
                                name="vio_StartDate"
                                onBlur={(e) => validateField(e.target.name, e.target.value)}
                                value={formValues.vio_StartDate}
                                onChange={(e) => handleDateChange("vio_StartDate", e.value)}
                                placeholder="VIO Start Date*"
                            />
                        </div>
                        {formErrors.vio_StartDate && <div className="error-text">{formErrors.vio_StartDate}</div>}

                        <div className="form-row-date" style={{ marginBottom: formErrors.vio_EndDate ? "0rem" : "0.7rem" }}>
                            <DatePicker
                                name="vio_EndDate"
                                value={formValues.vio_EndDate}
                                onBlur={(e) => validateField(e.target.name, e.target.value)}
                                onChange={(e) => handleDateChange("vio_EndDate", e.value)}
                                placeholder="VIO End Date*"
                            />
                        </div>
                        {formErrors.vio_EndDate && <div className="error-text">{formErrors.vio_EndDate}</div>}

                        {/* Allow Child Access */}
                        <div className="form-row-child">
                            <Checkbox
                                name="allowedChildren"
                                checked={formValues.allowedChildren}
                                onChange={handleCheckBox}
                                label="Allow Child Access"
                            />
                        </div>

                        {/* Form Actions */}
                        <div className="form-actions">
                            <Button onClick={handleRegister}>Register</Button>
                            <Button onClick={handleCancel}>Cancel</Button>
                        </div>
                    </form>
                </div>
            </div>
        </div >
    )
}

export default UserRegisteration